import api from './api';

/**
 * Get user's wishlist from backend
 */
export const getWishlist = async () => {
  try {
    const response = await api.get('/wishlist');
    if (response.data.success) {
      const wishlist = response.data.data.wishlist || [];
      // Extract car IDs from wishlist items
      const carIds = wishlist.map(item => {
        // Handle both direct carId and nested car object
        if (item.carId) {
          return String(item.carId); // Ensure string format
        }
        if (item.car && item.car.id) {
          return String(item.car.id); // Ensure string format
        }
        return null;
      }).filter(Boolean); // Remove any undefined/null values
      
      return carIds;
    }
    return [];
  } catch (error) {
    console.error('Error fetching wishlist:', error);
    if (error.response?.status === 401) {
      // Not authenticated, return empty array
      return [];
    }
    return [];
  }
};

/**
 * Add car to wishlist
 */
export const addToWishlist = async (carId) => {
  try {
    const response = await api.post('/wishlist', { carId });
    return response.data.success;
  } catch (error) {
    console.error('Error adding to wishlist:', error);
    throw error;
  }
};

/**
 * Remove car from wishlist
 */
export const removeFromWishlist = async (carId) => {
  try {
    const response = await api.delete(`/wishlist/${carId}`);
    return response.data.success;
  } catch (error) {
    console.error('Error removing from wishlist:', error);
    throw error;
  }
};

